<template>
  <div class="dashboard">
    <div class="row row-equal">
      <div class="flex md12">
        <va-card>
          <div class="row row-inside">
            <div class="flex md6">
              <div class="row row-inside">
                <va-button-toggle
                  color="info"
                  outline
                  class="toggle-activite"
                  v-model="showSyndicat"
                  :options="optionsSyndicat"
                />
                <va-popover
                  message="Email à destination de tous les adhérents"
                  placement="left"
                >
                  <va-button
                    class="ma-0 pb-3"
                    flat
                    color="info"
                    @click="openCourrielForAll()"
                  >
                    <va-icon size="15px" name="fa fa-envelope" />
                  </va-button>
                </va-popover>
              </div>
            </div>
            <div class="flex md4 vertical-center">
              Contact: {{ contact.titre }} {{ contact.nom }}
              {{ contact.prenom }}
              <va-popover message="Modifier le contact" placement="left">
                <va-button
                  class="ma-0"
                  small
                  flat
                  color="info"
                  @click="updateContact"
                >
                  <va-icon size="15px" name="fa fa-pencil" /> </va-button
              ></va-popover>
              <va-popover
                message="Email à destination du contact"
                placement="left"
              >
                <va-button
                  class="ma-0"
                  small
                  flat
                  color="info"
                  @click="openCourriel(contact.email)"
                  :disabled="!contact.email"
                >
                  <va-icon size="15px" name="fa fa-envelope" />
                </va-button>
              </va-popover>
            </div>
            <div class="flex md1 offset--md1">
              <va-popover
                message="Créer un appel à cotisation"
                placement="left"
              >
                <va-button
                  color="info"
                  class="create-button"
                  @click="showAdtCreation = true"
                >
                  <va-icon size="25px" name="fa fa-plus" />
                </va-button>
              </va-popover>
            </div>
          </div>
          <div class="row row-inside">
            <div class="flex md12">
              <va-data-table
                class="va-table--hoverable va-table--stripped"
                :fields="fields"
                :data="listAdhesions"
                :no-data-label="$t('poissonnierTable.empty')"
                :per-page="15"
                @row-clicked="showAdhesion"
                clickable
              >
                <template slot="status" slot-scope="props">
                  <p>{{ getStatus(props.rowData) }}</p>
                </template>
                <template slot="montant_adhesion" slot-scope="props">
                  <p>{{ props.rowData.montant_adhesion }} €</p>
                </template>
                <template slot="nb_entreprises" slot-scope="props">
                  <div class="row row-inside">
                    <div class="flex md4">
                      <p>{{ props.rowData.listEntreprise.length }}</p>
                    </div>
                    <div class="flex md1 pa-2">
                      <va-button
                        flat
                        color="info"
                        icon="fa fa-search"
                        @click="showListEntreprise(props.rowData)"
                      />
                    </div>
                  </div>
                </template>
                <template slot="montant_total" slot-scope="props">
                  <p>{{ props.rowData.montant_total }} €</p>
                </template>

                <template slot="actions" slot-scope="props">
                  <div class="row row-inside ma-2">
                    <div class="flex md12">
                      <va-button
                        class="fullwidth"
                        outline
                        :color="props.rowData.date_rappel ? 'success' : 'info'"
                        @click="getAppel(props.rowData)"
                        >Appel à cotisation</va-button
                      >
                    </div>
                    <div class="flex md12">
                      <va-button
                        :disabled="!props.rowData.idpaiement_type"
                        class="fullwidth"
                        :color="props.rowData.date_recu ? 'success' : 'info'"
                        outline
                        @click="getRecu(props.rowData)"
                        >Edition reçu</va-button
                      >
                    </div>
                  </div>
                </template>
              </va-data-table>
            </div>
          </div>
        </va-card>
      </div>
    </div>
    <ContactModal
      :showEditor="showContactEditor"
      :idsyndicat="showSyndicat"
      @close="showContactEditor = false"
      @updateContact="getContact"
    />

    <CreationAdhesion
      :showEditor="showAdtCreation"
      :idsyndicat="showSyndicat"
      @close="showAdtCreation = false"
      @updateList="getAdhesionsList()"
    />
    <ModificationAdhesion
      :showEditor="showAdtModification"
      :idAdt="idAdtModification"
      @close="showAdtModification = false"
      @updateList="getAdhesionsList()"
    />

    <va-modal
      large
      title="Liste entreprises"
      class="modal"
      v-model="showEntList"
      okText="Fermer"
      v-on:ok="showEntList = false"
    >
      <div
        class="row row-inside my-2"
        v-for="(element, index) in listEntreprises"
        :key="element.identreprise"
      >
        <div class="flex md12">
          <b> {{ index + 1 }} - {{ element.nom }}</b>
        </div>
        <div class="flex md12">
          {{ element.adresse_ligne_1 }}
        </div>
        <div class="flex md12">
          {{ element.adresse_ligne_2 }}
        </div>
        <div class="flex md12">
          {{ element.adresse_ville_complete }}
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import moment from "moment";

import axios from "axios";
import ContactModal from "./ContactModal";
import CreationAdhesion from "./CreationAdhesion";
import ModificationAdhesion from "./ModificationAdhesion";

export default {
  name: "dashboard",
  // props: ["nomadh"],
  components: { ContactModal, CreationAdhesion, ModificationAdhesion },
  data() {
    return {
      listEntreprises: [],
      showEntList: false,
      idAdtModification: null,
      showAdtModification: false,
      showContactEditor: false,
      showAdtCreation: false,
      optionsSyndicat: [
        { label: "OPAM-B", value: "opam" },
        { label: "AGROMER", value: "agromer" },
        { label: "SCAPP", value: "scapp" },
        { label: "Languedoc-Roussillon", value: "Languedoc-Roussillon" },
        { label: "Vendée", value: "Vendee" },
        { label: "S.D.E.P.", value: "SDEP" },
      ],
      showSyndicat: "opam",
      contact: {
        titre: "test",
        nom: "test",
        prenom: "test",
      },
      listAdhesions: [],
      isaction: false,
    };
  },
  computed: {
    idOrganisation() {
      if (this.showSyndicat === "opam") {
        return 2;
      } else if (this.showSyndicat === "agromer") {
        return 3;
      } else if (this.showSyndicat === "scapp") {
        return 1;
      } else if (this.showSyndicat === "Languedoc-Roussillon") {
        return 6;
      } else if (this.showSyndicat === "Vendee") {
        return 4;
      } else if (this.showSyndicat === "SDEP") {
        return 7;
      } else {
        console.log("no organisation selected");
        return null;
      }
    },
    fields() {
      return [
        {
          name: "annee",
          title: "Année",
          sortField: "annee",
          width: "10%",
        },

        {
          name: "__slot:status",
          title: "Status",
          width: "15%",
        },
        {
          name: "__slot:montant_adhesion",
          title: "Montant",
          sortField: "montant_adhesion",
          width: "10%",
        },
        {
          name: "__slot:nb_entreprises",
          title: "Nombre d'entreprises",
          sortField: "nb_entreprises",
          width: "10%",
        },

        {
          name: "__slot:montant_total",
          title: "Montant total",
          sortField: "montant_total",
          width: "10%",
        },
        {
          name: "__slot:actions",
          title: "Actions",
          width: "20%",
        },
      ];
    },
  },
  methods: {
    async openCourrielForAll() {
      try {
        let results = await axios.get("/api/adt/emails-organisation", {
          params: { idorganisation: this.idOrganisation },
        });
        this.openCourriel(null, results.data);
      } catch (error) {
        console.log(error);
        this.showToast("Erreur lors de l'ouverture de l'email", {
          position: "bottom-center",
          duration: 5000,
        });
      }
    },
    openCourriel(toemails, bccemails) {
      if (!toemails && !bccemails) {
        this.showToast("Emails non définis", {
          position: "bottom-center",
          duration: 5000,
        });
        return;
      }
      let mailto = "mailto:";
      if (toemails) {
        mailto = mailto + toemails;
      }

      if (bccemails) {
        mailto = mailto + "?bcc=" + bccemails;
      }

      window.open(mailto);
    },
    async getRecu(rowData) {
      this.isaction = true;
      try {
        if (!rowData.idrappel_adhesions_tierce) {
          return;
        }

        let pdfurl = await axios.get("api/adt/recu", {
          params: { idadhesion: rowData.idrappel_adhesions_tierce },
        });
        this.openNewTab(pdfurl.data);
      } catch (error) {
        console.log(error);
      }
    },
    async getAppel(rowData) {
      this.isaction = true;
      try {
        if (!rowData.idrappel_adhesions_tierce) {
          return;
        }

        let pdfurl = await axios.get("api/adt/appel", {
          params: { idadhesion: rowData.idrappel_adhesions_tierce },
        });
        this.openNewTab(pdfurl.data);
      } catch (error) {
        console.log(error);
      }
    },
    openNewTab(url) {
      try {
        window.open(url, "_blank");
        this.ok();
      } catch (err) {}
    },
    showListEntreprise(rowData) {
      this.isaction = true;
      //todo display list entreprise
      this.listEntreprises = rowData.listEntreprise;
      this.showEntList = true;
    },
    getStatus(rowData) {
      console.log(rowData);
      if (rowData.date_recu) {
        return (
          "Reçu généré le " + moment(rowData.date_recu).format("DD-MM-YYYY")
        );
      } else if (rowData.date_paiement) {
        return (
          "Paiement enregistré le " +
          moment(rowData.date_paiement).format("DD-MM-YYYY")
        );
      } else if (rowData.date_rappel) {
        return (
          "Rappel généré le " + moment(rowData.date_rappel).format("DD-MM-YYYY")
        );
      } else if (rowData.date_creation) {
        return "Créé le " + moment(rowData.date_creation).format("DD-MM-YYYY");
      } else {
        return "Erreur";
      }
    },
    showAdhesion(rowData) {
      if (this.isaction) {
        this.isaction = false;
        return;
      }
      this.idAdtModification = rowData.idrappel_adhesions_tierce;
      this.showAdtModification = true;
    },
    async getAdhesionsList() {
      try {
        this.idAdtModification = null;
        if (this.idOrganisation) {
          let results = await axios.get("/api/adt/listAdhesions", {
            params: { idorganisation: this.idOrganisation },
          });

          console.log("listadhesion", results.data);
          this.listAdhesions = results.data;
        } else {
          console.log("error organisation not selected");
        }
      } catch (error) {
        console.log(error);
        this.listAdhesions = [];
      }
    },
    async getContact() {
      try {
        if (!this.idOrganisation) {
          console.log("no organisation selected");
          return;
        }
        let results = await axios.get("/api/adt/contact", {
          params: { idorg: this.idOrganisation },
        });
        if (results.data) {
          this.contact = results.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    createAdhesion() {},
    updateContact() {
      this.showContactEditor = true;
    },
  },

  mounted() {
    this.getContact();
    this.getAdhesionsList();
  },
  watch: {
    showSyndicat() {
      this.getContact();
      this.getAdhesionsList();
    },
  },
};
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0;
  }
}

.fullwidth {
  width: 95%;
}
.vertical-center {
  position: relative;
  top: 0.5em;
}
</style>
